import type { MessageDescriptor } from "@lingui/core";
import { detect, fromNavigator } from "@lingui/detect-locale";
import { isObject } from "lodash/fp";

import {
  DEFAULT_LANGUAGE_CODE,
  EMPTY_DELIMITER,
  SPACE_DELIMITER,
} from "@readai/common/constants/locales";
import { LanguageCode, WordDelimiter } from "@readai/common/types";

/**
 * Get the user's browser language, falling back to english
 */
export const USER_REQUESTED_LOCALE =
  detect(fromNavigator(), DEFAULT_LANGUAGE_CODE) || DEFAULT_LANGUAGE_CODE;

export const getDelimiterForLanguage = (
  languageCode: LanguageCode,
): WordDelimiter => {
  switch (languageCode) {
    case "ja":
    case "yue":
    case "zh":
      return EMPTY_DELIMITER;
    default:
      return SPACE_DELIMITER;
  }
};

const isObjectLiteral = (value: unknown): value is object =>
  isObject(value) && !Array.isArray(value);

export const isMessageDescriptor = (
  value: unknown,
): value is MessageDescriptor => isObjectLiteral(value) && "id" in value;
